import RequestMethods from './request.methods'
import axios from 'axios'
import qs from 'qs'
// import GlsxVueCommon from 'glsx-vue-common'
import sign from './sign'
import GlAxios from '../common/axios'
const request = (
  params = {},
  method = RequestMethods.GET,
  noSignAttr = [],
  url = '',
  isMd5 = false,
  isParams=true
) => {
  params.source = 'glsx-oss-merchant-data'
  params.appKey = '48e5e13229b82c1b4e6e8c96151f0637'
  params.timestamp = new Date().getTime()
  params.v = '1.0.0'
  params.format = 'json'
  // params.sessionAuth = 'st'
  var _p = location.search.substr(1).match(new RegExp('(^|&)t=([^&]*)(&|$)', 'i'))
  if (_p && _p.length) {
    params.sessionId = _p[2]
  }
  // params.createBy = this.$get_session_config().user.id
  if (isMd5) {
    params.app_key = params.appKey
    delete params.appKey
    // return axios.post(`${url}/router?method=${method}`, qs.stringify(data))
  }
  var data = isMd5 ? sign(params, noSignAttr, true) : sign(params, noSignAttr)
  if (url && isParams) {
    return axios.post(`${url}/router?method=${method}`, qs.stringify(data))
  }
  if (url && !isParams) {
    return axios.post(`${url}/router`, qs.stringify(data))
  }
  return method === RequestMethods.GET
    ? GlAxios.get('router', {
        params: sign(params, noSignAttr),
      })
    : GlAxios.post('router', data)
}
export default request
